<template>
    <section class="prebuild-pc-banner">
        <div class="row">
            <div class="col-md-6" v-for="section in sectionsData" :key="section.id">
                <prebuild-pc-section :section-data="section" :should-use-mobile-background="shouldUseMobileBackground"/>
            </div>
        </div>
    </section>
</template>

<script>
import { isMobile } from "@u/helpers.js";
import PrebuildPcSection from "./prebuild-pc-section";

export default {
    name: "PrebuildPcsBanner",
    components: {
        PrebuildPcSection
    },
    data() {
        return {
            shouldUseMobileBackground: false
        }
    },
    created() {
        this.shouldUseMobileBackground = isMobile();

        $(window).resize(_.throttle(() => {
            this.shouldUseMobileBackground = $(window).width() <= 600;
        }, 250));
    },
    computed: {
        sectionsData() {
            const landingSections = CONFIG.STARTER_PC_BUILDS.pageData.landing_page_sections;

            return [
                {
                    ...landingSections[6],
                    className: "top-left",
                    landingPageRoute: "starter-series",
                    mobileBackground: "/images/section-images/backgrounds/prebuild-section/starter-pc-mobile-bg.jpg",
                    trackEvent: "SP"
                },
                {
                    ...landingSections[9],
                    className: "top-right",
                    landingPageRoute: "streaming-pc",
                    mobileBackground: "/images/section-images/backgrounds/prebuild-section/streaming-pc-mobile-bg.jpg",
                    trackEvent: "Streaming PC"
                },
                {
                    ...landingSections[8],
                    className: "bottom-left",
                    landingPageRoute: "h1-mini-pc",
                    mobileBackground: "/images/section-images/backgrounds/prebuild-section/h1-mini-mobile-bg.jpg",
                    trackEvent: "H1 Mini pc"
                },
                {
                    ...landingSections[10],
                    className: "bottom-right",
                    landingPageRoute: "creator-pc",
                    mobileBackground: "/images/section-images/backgrounds/prebuild-section/creator-pc-mobile-bg.jpg",
                    trackEvent: "CP"
                }
            ]
        },
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

</style>
